import styles from './Form.module.css';
import imgUberUns1 from './imgUberUns1.png'
import imgUberUns2 from './imgUberUns2.png'
import {Zoom} from "react-awesome-reveal";
import React from "react";
function Form(props) {
  return (
      <div>

          <div style={{background: '#276A9F'}}>
              <center>
                  <div className={styles.header}>Erfahrung, die Vertrauen schaff</div>
              </center>
          </div>

          <div className="wrapper">

              <div className="grid">
                  <div className="displayLarge lg:col-6 col-12">
                      <div style={{paddingTop: '20px'}}>
                          <div style={{width: '50%', float: "left"}}>
                              <Zoom direction="left" triggerOnce>
                                  <img className={styles.img} src={imgUberUns1}/>
                              </Zoom>
                          </div>
                          <div style={{width: '50%', float: "left", marginLeft: '-10%', marginTop: '10%'}}>
                              <Zoom direction="right" triggerOnce>
                                  <img className={styles.img} src={imgUberUns2}/>
                              </Zoom>
                          </div>
                      </div>
                  </div>
                  <div className={" lg:col-6 col-12"}>
                      <Zoom triggerOnce direction="right">
                          <div style={{
                              borderRadius: 15
                              , background: 'rgba(255,255,255,0.4)'
                              , padding: 25
                          }}>

                              <div>
                                  In den letzten Jahren durften wir zahlreiche Kunden aus verschiedensten Branchen unterstützen — unter anderem:
                                  <br/>
                                  <ul>
                                      <li style={{paddingBottom: 10}}>Führende internationale Einrichtungshäuser</li>
                                      <li style={{paddingBottom: 10}}>Nationale und internationale Messen sowie Großveranstaltungen</li>
                                      <li style={{paddingBottom: 10}}>Renommierte Kongress- und Tagungszentren</li>
                                      <li style={{paddingBottom: 10}}>Professionelle Immobilienverwaltungen und Bürokomplexe</li>
                                  </ul>




                              </div>
                          </div>

                      </Zoom>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Form;
